import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../Home/components/Navbar';
import { Footer } from '../Home/components/Footer';
import './StaticPages.css';

export const Help = () => {
  const helpTopics = [
    {
      icon: "📅",
      title: "Booking Events",
      description: "Learn how to find, book, and manage your event reservations.",
      link: "/faq"
    },
    {
      icon: "💳",
      title: "Payments & Refunds",
      description: "Information about payment methods, billing, and refund policies.",
      link: "/faq"
    },
    {
      icon: "👤",
      title: "Account Settings",
      description: "Manage your profile, notifications, and account preferences.",
      link: "/profile"
    },
    {
      icon: "🎫",
      title: "Event Organizers",
      description: "Resources for hosting and managing events on Hobi.",
      link: "/faq"
    },
    {
      icon: "🔒",
      title: "Safety & Trust",
      description: "Learn about our safety measures and community guidelines.",
      link: "/privacy"
    },
    {
      icon: "📱",
      title: "Technical Support",
      description: "Troubleshooting and technical help for our platform.",
      link: "/contact"
    }
  ];

  return (
    <div className="static-page-wrapper hero-bg-listing-creative">
      <Navbar dark={true} />
      
      <div className="static-page-hero">
        <h1 className="static-page-title">Help Center</h1>
        <p className="static-page-subtitle">How can we help you today?</p>
      </div>

      <main className="static-page-content">
        <div className="static-page-container">
          <div className="help-search">
            <input 
              type="text" 
              placeholder="Search for help articles..." 
              className="help-search-input"
            />
            <button className="help-search-btn">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
                <circle cx="11" cy="11" r="8"/>
                <path d="M21 21l-4.35-4.35"/>
              </svg>
            </button>
          </div>

          <div className="help-topics-grid">
            {helpTopics.map((topic, index) => (
              <Link to={topic.link} key={index} className="help-topic-card">
                <span className="help-topic-icon">{topic.icon}</span>
                <h3>{topic.title}</h3>
                <p>{topic.description}</p>
              </Link>
            ))}
          </div>

          <section className="static-section text-center">
            <h2>Still need help?</h2>
            <p>Our support team is here to assist you</p>
            <Link to="/contact" className="contact-support-btn">Contact Support</Link>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};
